import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/eb7a06ed03bb4502c9148cf086094d6f.jpg)'
        }}
      ></div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 md:py-32 text-center w-full">
        {/* Badge */}
        <div className="inline-block bg-white/10 backdrop-blur-sm text-white px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold mb-6 sm:mb-8 border border-white/20">
          SERVING THE NORTH SHORE & BEYOND SINCE 2021
        </div>

        {/* Main Headline */}
        <h1 className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold leading-tight mb-6 sm:mb-8 px-4">
          Stay in the Home You Love, With the Safety You Deserve.
        </h1>

        {/* Subheadline */}
        <p className="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl font-light mb-8 sm:mb-10 md:mb-12 max-w-4xl mx-auto px-4 leading-relaxed">
          Professional home safety modifications that let seniors age in place with confidence. From grab bars to full accessibility upgrades.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5 mb-12 sm:mb-16 px-4">
          <button
            onClick={() => navigate('/free-assessment')}
            className="w-full sm:w-auto bg-[#D4AF37] hover:bg-[#C4A137] text-[#1A2B4A] px-8 sm:px-10 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            Schedule Free Assessment
          </button>
          <a
            href="tel:6175396650"
            className="w-full sm:w-auto group bg-transparent border-2 border-white hover:bg-white text-white hover:text-[#1A2B4A] px-8 sm:px-10 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-3"
          >
            <i className="ri-phone-line text-lg sm:text-xl"></i>
            Call (617) 539-6650
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-8 md:gap-12 text-white/90 text-sm sm:text-base px-4">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-[#D4AF37] text-xl sm:text-2xl"></i>
            <span className="font-medium">Licensed & Insured</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-time-line text-[#D4AF37] text-xl sm:text-2xl"></i>
            <span className="font-medium">Fast Installation</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-star-line text-[#D4AF37] text-xl sm:text-2xl"></i>
            <span className="font-medium">Quality Guaranteed</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </section>
  );
}
